const LOCATION_QUERY_KEYS = [
  "location[format]",
  "location[cfi]",
  "location[page]",
  "location[y]"
]

export function consumeReaderLocation() {
  const url = new URL(window.location.href)
  const hasLocation = LOCATION_QUERY_KEYS.some((key) => url.searchParams.has(key))
  if (!hasLocation) return

  LOCATION_QUERY_KEYS.forEach((key) => url.searchParams.delete(key))
  window.history.replaceState(window.history.state, "", `${url.pathname}${url.search}${url.hash}`)
}
